import styled from "@emotion/styled"
import SectionWrapper from "../../components/section-wrapper/section-wrapper.component"
import { Container, Typography } from "@mui/material"
import CustomImage from "../../components/custom-image/custom-image.component"

export const Section = styled(SectionWrapper)`
  padding: ${({ theme }) => theme.typography.pxToRem(100)} 0;
  ${({ theme }) => theme.breakpoints.up("md")} {
    padding: ${({ theme }) => theme.typography.pxToRem(160)} 0;
  }
`

export const Wrapper = styled(Container)`
  display: flex;
  justify-content: center;
  align-items: center;
  flex-direction: column;
`

export const Title = styled(Typography)`
  color: ${({ theme }) => theme.palette.primary.main};
  text-align: center;
  font-size: ${({ theme }) => theme.typography.pxToRem(52)};
  font-style: normal;
  font-weight: 500;
  line-height: ${({ theme }) => theme.typography.pxToRem(68)};
  max-width: 735px;
  margin-bottom: ${({ theme }) => theme.typography.pxToRem(56)};

  ${({ theme }) => theme.breakpoints.down("md")} {
    font-size: ${({ theme }) => theme.typography.pxToRem(36)};
    line-height: ${({ theme }) => theme.typography.pxToRem(44)};
  }
`

export const CardContainer = styled.div`
  border-radius: 24px;
  border: 1px solid rgba(128, 208, 188, 0.55);
  background: ${({ theme }) => theme.palette.secondary.light};
  padding: 2rem 2.2rem;

  display: flex;
  flex-direction: column;
  justify-content: space-between;
  align-items: flex-start;
  height: 277px;
`
export const TopContainer = styled.div``

export const Place = styled.div`
  border-radius: 46px;
  border: 1px solid rgba(0, 128, 96, 0.1);
  display: flex;
  padding: 3.5px 14px;
  justify-content: center;
  align-items: center;
  gap: 8px;
  width: fit-content;

  p {
    color: ${({ theme }) => theme.palette.tertiary.dark};
    font-size: ${({ theme }) => theme.typography.pxToRem(16)};
    font-style: normal;
    font-weight: 400;
    line-height: ${({ theme }) => theme.typography.pxToRem(24)};
  }
`

export const Position = styled(Typography)`
  color: ${({ theme }) => theme.palette.primary.main};
  font-size: ${({ theme }) => theme.typography.pxToRem(24)};
  font-style: normal;
  font-weight: 300;
  line-height: ${({ theme }) => theme.typography.pxToRem(32)};
  margin-bottom: 1rem;
`

export const BestPlacesCard = styled.div`
  border-radius: 24px;
  background: linear-gradient(108deg, #006e56 -30.62%, #00a179 60.1%);
  display: flex;
  height: 277px;
  padding: 32px;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  gap: 37px;
`

export const Description = styled(Typography)`
  color: ${({ theme }) => theme.palette.primary.light};
  font-size: ${({ theme }) => theme.typography.pxToRem(17)};
  font-style: normal;
  font-weight: 700;
  line-height: normal;
  letter-spacing: 0.34px;
  text-transform: uppercase;
  opacity: 0.8;
`

export const Image = styled(CustomImage)`
  max-width: 120px;
  img {
    max-width: 120px;
  }
`
export const Text = styled(Typography)`
  text-align: center;
  font-size: 1.25rem;
  font-weight: 500;
  line-height: 28px;
  margin-bottom: 3rem;
  color: ${({ theme }) => theme.palette.text.content};
`
export const NoOpenImage = styled(CustomImage)`
  display: flex;
  img {
    margin: auto;
  }
  margin-bottom: 2rem;
  ${({ theme }) => theme.breakpoints.up("md")} {
    margin-bottom: 3rem;
  }
`
